import React from 'react';
import { useCategoriesContext } from 'components/shared/Categories';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { PER_PAGE, VIP_PER_PAGE, DYNAMIC_CONTENT_REVALIDATION_TIME } from 'constants/';
import { getRequest } from 'modules/request';
import { Cards } from 'components/ant/ui/Cards';
import { EmptyLayout } from 'components/ant/layouts';

const Page = ({ listings, vip, page, contains, location, slug }) => {
  const { findCategory } = useCategoriesContext();
  const { query } = useRouter();
  const title = findCategory('slug', query.slug)?.name;

  return (
    <EmptyLayout>
      <Cards listings={listings} slug={slug} location={location} vip={vip} page={page} />
    </EmptyLayout>
  );
};

export const getStaticProps = async (ctx) => {
  const { slug, contains = null, location, page } = ctx.params;

  const vip = await getRequest()
    .get('/listings')
    .query({ contains, location, page, perPage: VIP_PER_PAGE, isVip: true })
    .then((res) => ({
      ...res.body,
      count: parseInt(res.body.count),
    }))
    .catch((err) => {
      return [];
    });

  const listings = await getRequest()
    .get('/listings')
    .query({ 'categories[]': slug, contains, location, page, perPage: PER_PAGE, isVip: false })
    .then((res) => ({
      ...res.body,
      count: parseInt(res.body.count),
    }));

  return {
    props: {
      listings,
      vip,
      page,
      contains,
      location,
      slug,
      ...(await serverSideTranslations(ctx.locale, ['common'])),
    },
    revalidate: DYNAMIC_CONTENT_REVALIDATION_TIME,
  };
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: false,
  };
};

export default Page;
